/**
 * gem-color-swap.js  v32
 *
 * v31からの変更点:
 *   - findTooltipTarget() から .mw-option__value を除外。
 *     テキスト・価格部分にホバーしてもツールチップが出ないよう修正。
 *     画像エリア（swatch-media / swatch-image / stack__item-swatch）のみ対象。
 */

(function () {
  'use strict';

  /* -------------------------------------------------------
     デバッグログ
  ------------------------------------------------------- */

  function log() {
    if (window.GEM_SWAP_DEBUG) {
      console.log.apply(console, ['[gem-color-swap]'].concat(Array.prototype.slice.call(arguments)));
    }
  }

  function warn() {
    if (window.GEM_SWAP_DEBUG) {
      console.warn.apply(console, ['[gem-color-swap]'].concat(Array.prototype.slice.call(arguments)));
    }
  }

  /* -------------------------------------------------------
     カラー定義
  ------------------------------------------------------- */

  var COLOR_MAP = [
    { keywords: ['K14 ローズ', 'K14ローズ', 'K１４ローズ', 'K１４ ローズ',
                 'K10 ローズ', 'K10ローズ', 'K１０ローズ', 'K１０ ローズ'],
      key: 'rose' },
    { keywords: ['K14 ホワイト', 'K14ホワイト', 'K１４ホワイト', 'K１４ ホワイト',
                 'K14 ロジウム', 'K14ロジウム', 'K１４ロジウム', 'K１４ ロジウム',
                 'K10 ホワイト', 'K10ホワイト', 'K１０ホワイト', 'K１０ ホワイト',
                 'K10 ロジウム', 'K10ロジウム', 'K１０ロジウム', 'K１０ ロジウム'],
      key: 'platinum' },
    { keywords: ['K10 イエロー', 'K10イエロー', 'K１０イエロー', 'K１０ イエロー'],
      key: 'yellow10' },
    { keywords: ['K14 イエロー', 'K14イエロー', 'K１４イエロー', 'K１４ イエロー'],
      key: 'yellow14' },
    { keywords: ['K10', 'K１０'],        key: 'yellow10'  },
    { keywords: ['K14', 'K１４'],        key: 'yellow14'  },
    { keywords: ['イエロー'],             key: 'yellow'    },
    { keywords: ['ローズ'],               key: 'rose'      },
    { keywords: ['ホワイト', 'ロジウム'], key: 'platinum'  },
  ];

  var PLATINUM_KEYWORDS = ['PT', 'プラチナ', 'Pt'];

  function detectColorKey(text) {
    for (var i = 0; i < COLOR_MAP.length; i++) {
      var entry = COLOR_MAP[i];
      for (var j = 0; j < entry.keywords.length; j++) {
        if (text.indexOf(entry.keywords[j]) !== -1) return entry.key;
      }
    }
    return null;
  }

  function isPlatinum(text) {
    for (var i = 0; i < PLATINUM_KEYWORDS.length; i++) {
      if (text.indexOf(PLATINUM_KEYWORDS[i]) !== -1) return true;
    }
    return false;
  }

  /* -------------------------------------------------------
     テキスト取得
  ------------------------------------------------------- */

  function getMetalText(el) {
    var optionValue = el.closest('.mw-option__value');
    if (optionValue) return optionValue.textContent || '';
    var stack = el.closest('.mw-stack');
    if (stack) return stack.textContent || '';
    var btn = el.closest('.mw-option__button');
    if (btn) return btn.textContent || '';
    return el.textContent || '';
  }

  function getColorKeyFromElement(el) {
    var optionValue = el.closest('.mw-option__value');
    if (optionValue) {
      var textEl = optionValue.querySelector('.mw-option__value-text');
      if (textEl) return detectColorKey(textEl.textContent || '');
      var label = optionValue.querySelector('label, .mw-label');
      if (label) return detectColorKey(label.textContent || '');
      return detectColorKey(optionValue.textContent || '');
    }
    var stack = el.closest('.mw-stack');
    if (stack) {
      var textEl2 = stack.querySelector('.mw-option__value-text');
      if (textEl2) return detectColorKey(textEl2.textContent || '');
      return detectColorKey(stack.textContent || '');
    }
    var btn = el.closest('.mw-option__button');
    if (btn) return detectColorKey(btn.textContent || '');
    return detectColorKey(el.textContent || '');
  }

  /* -------------------------------------------------------
     宝石番号取得
     1点もの: #001 → "001"
     stock:   [stock1] → "stock1"
  ------------------------------------------------------- */

  function getStoneOptionEl() {
    var options = document.querySelectorAll('.mw-option[data-option-id]');
    for (var i = 0; i < options.length; i++) {
      var title = options[i].querySelector('.mw-option__title, .mw-label, [class*="title"]');
      if (title && title.textContent.indexOf('お石') !== -1) {
        return options[i];
      }
    }
    return null;
  }

  function getStoneNumber() {
    var stoneOption = getStoneOptionEl();
    if (!stoneOption) return null;

    var checked = stoneOption.querySelector('input.mw-option__control:checked');
    if (checked) {
      var valueEl = checked.closest('.mw-option__value');
      if (valueEl) {
        var nameEl = valueEl.querySelector('[data-original-text]');
        var text = nameEl ? nameEl.getAttribute('data-original-text') : (valueEl.textContent || '');
        var stockMatch = text.match(/\[stock(\w+)\]/i);
        if (stockMatch) return 'stock' + stockMatch[1];
        var ittenMatch = text.match(/#(\d{3})/);
        if (ittenMatch) return ittenMatch[1];
        var img = valueEl.querySelector('img');
        if (img) {
          var src = img.src || img.getAttribute('data-lazy-src') || '';
          var filename = src.split('?')[0].split('/').pop();
          var stockFile = filename.match(/-(stock\w+)[-_]/i);
          if (stockFile) return stockFile[1];
        }
      }
    }

    var allValues = stoneOption.querySelectorAll('.mw-option__value');
    for (var i = 0; i < allValues.length; i++) {
      var v = allValues[i];
      if (v.style.display === 'none') continue;
      var nameEl2 = v.querySelector('[data-original-text]');
      var text2 = nameEl2 ? nameEl2.getAttribute('data-original-text') : (v.textContent || '');
      var stockMatch2 = text2.match(/\[stock(\w+)\]/i);
      if (stockMatch2) return 'stock' + stockMatch2[1];
      var ittenMatch2 = text2.match(/#(\d{3})/);
      if (ittenMatch2) return ittenMatch2[1];
      var img2 = v.querySelector('img');
      if (img2) {
        var src2 = img2.src || img2.getAttribute('data-lazy-src') || '';
        var filename2 = src2.split('?')[0].split('/').pop();
        var stockFile2 = filename2.match(/-(stock\w+)[-_]/i);
        if (stockFile2) return stockFile2[1];
      }
    }

    return null;
  }

  /* -------------------------------------------------------
     地金カラーオプションにクラスを付与
     ▼ v31修正: 「地金カラー」に加え「カラーを選び」も対象に追加
  ------------------------------------------------------- */

  function tagMetalColorOption() {
    var options = document.querySelectorAll('.mw-option[data-option-id]');
    options.forEach(function (option) {
      var title = option.querySelector('.mw-option__title, .mw-label, [class*="title"]');
      if (title && (
        title.textContent.indexOf('地金カラー') !== -1 ||
        title.textContent.indexOf('カラーを選び') !== -1
      )) {
        option.classList.add('gem-metal-color-option');
      }
    });
  }

  /* -------------------------------------------------------
     画像を高解像度版URLに変換
  ------------------------------------------------------- */

  function upgradeImageSrc(src) {
    if (!src) return src;
    if (src.indexOf('{width}') !== -1 || src.indexOf('%7Bwidth%7D') !== -1) return src;
    return src.replace(/_([\d]+x[\d]*(@[\dx]+)?)\./, '_1200x.');
  }

  /* -------------------------------------------------------
     画像検索（末尾一致）
  ------------------------------------------------------- */

  function findProductImage(filename) {
    var pattern = new RegExp(filename.replace(/[-]/g, '\\-') + '[^a-zA-Z0-9]', 'i');
    var allImgs = document.querySelectorAll('img');
    for (var i = 0; i < allImgs.length; i++) {
      var src = allImgs[i].src
             || allImgs[i].getAttribute('data-lazy-src')
             || '';
      if (pattern.test(src)) return upgradeImageSrc(src);
    }
    return null;
  }

  /* -------------------------------------------------------
     ファイル名組み立て
  ------------------------------------------------------- */

  function buildFilename(colorKey, stoneNum) {
    var config = window.GEM_SWAP_CONFIG;
    if (!config) return null;
    var parts = [config.prefix || 'fioreovale', config.stoneCode, config.size];
    if (stoneNum) parts.push(stoneNum);
    parts.push(colorKey);
    return parts.join('-');
  }

  function getColorImageSrc(colorKey) {
    var stoneNum = getStoneNumber();
    var filename = buildFilename(colorKey, stoneNum);
    return filename ? findProductImage(filename) : null;
  }

  /* -------------------------------------------------------
     ツールチップ（148×148px）
     地金カラースウォッチのホバー時に画像ポップアップを表示
  ------------------------------------------------------- */

  var tooltipEl = null;

  function getOrCreateTooltip() {
    if (tooltipEl) return tooltipEl;
    tooltipEl = document.createElement('div');
    tooltipEl.style.cssText = [
      'position:fixed',
      'z-index:99999',
      'pointer-events:none',
      'display:none',
      'width:148px',
      'height:148px',
      'border-radius:8px',
      'overflow:hidden',
      'box-shadow:0 4px 20px rgba(0,0,0,0.18)',
      'background:#f8f7f5',
      'border:1px solid #e8e4df',
    ].join(';');
    var img = document.createElement('img');
    img.id = 'gem-color-tooltip-img';
    img.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;';
    tooltipEl.appendChild(img);
    document.body.appendChild(tooltipEl);
    return tooltipEl;
  }

  function showTooltip(src, targetEl) {
    var tip = getOrCreateTooltip();
    var imgEl = document.getElementById('gem-color-tooltip-img');
    if (imgEl) imgEl.src = src;
    var size = (window.innerWidth <= 768) ? 180 : 148;
    tip.style.width  = size + 'px';
    tip.style.height = size + 'px';
    if (targetEl) {
      var rect = targetEl.getBoundingClientRect();
      tip.style.left = (rect.right + 10) + 'px';
      tip.style.top  = (rect.top + (rect.height / 2) - (size / 2)) + 'px';
    }
    tip.style.display = 'block';
    log('ツールチップ表示:', src);
  }

  function hideTooltip() {
    if (tooltipEl) tooltipEl.style.display = 'none';
  }

  // スクロール時にツールチップを非表示
  window.addEventListener('scroll', function () {
    hideTooltip();
  }, { passive: true });

  /* -------------------------------------------------------
     ツールチップ用ターゲット探索
     gem-metal-color-option 内のスウォッチのみ対象
  ------------------------------------------------------- */

  function findTooltipTarget(el) {
    var target = (
      el.closest('.mw-option__swatch-media') ||
      el.closest('.mw-option__swatch-image') ||
      el.closest('.mw-stack__item-swatch')
    );
    if (!target) return null;
    if (!target.closest('.gem-metal-color-option')) return null;
    return target;
  }

  /* -------------------------------------------------------
     プレビューサムネイル（Total:行の上）
  ------------------------------------------------------- */

  var PREVIEW_THUMB_ID      = 'gem-preview-thumb';
  var PREVIEW_WRAPPER_ID    = 'gem-preview-thumb-wrapper';
  var previewThumbInserted  = false;

  function getCurrentMainSrc() {
    var selectors = [
      '.product-media[style*="display: block"] img:not(.zoomImg)',
      '.product-media.is-active img:not(.zoomImg)',
      '.main .product-media img:not(.zoomImg)',
      '.product-media img:not(.zoomImg)'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el && el.src) return el.src;
    }
    return '';
  }

  function insertPreviewThumb() {
    if (document.getElementById(PREVIEW_WRAPPER_ID)) return;
    var anchor = document.querySelector('.payment-and-quantity');
    if (!anchor) return;
    var src = getCurrentMainSrc();
    if (!src) return;

    var wrapper = document.createElement('div');
    wrapper.id = PREVIEW_WRAPPER_ID;
    wrapper.style.cssText = [
      'display:none',
      'flex-direction:column',
      'align-items:center',
      'gap:10px',
      'width:100%',
      'margin-left:auto',
      'margin-right:auto',
      'box-sizing:border-box',
      'border-radius:8px',
      'background:linear-gradient(135deg,#fdf8f0 0%,#f7f0e4 100%)',
      'border:1px solid #d4b896',
      'padding:16px 0 24px 0',
      'margin-bottom:16px',
      'box-shadow:0 2px 12px rgba(180,140,90,0.10)',
    ].join(';');

    var label = document.createElement('span');
    label.style.cssText = [
      'font-size:10px',
      'letter-spacing:0.12em',
      'color:#b89a6a',
      'text-transform:uppercase',
      'font-weight:500',
      'line-height:1',
    ].join(';');
    label.innerText = '選択中のイメージ';

    var imgWrap = document.createElement('div');
    imgWrap.style.cssText = [
      'position:relative',
      'width:100%',
      'max-width:280px',
      'aspect-ratio:4/3',
      'border-radius:8px',
      'overflow:hidden',
      'background:#fff',
      'box-shadow:0 1px 6px rgba(180,140,90,0.15)',
    ].join(';');

    var thumb = document.createElement('img');
    thumb.id = PREVIEW_THUMB_ID;
    thumb.src = src;
    thumb.style.cssText = [
      'width:100%',
      'height:100%',
      'max-height:280px',
      'object-fit:contain',
      'display:block',
    ].join(';');

    var bar = document.createElement('div');
    bar.id = 'gem-preview-bar';
    bar.style.cssText = [
      'position:absolute',
      'bottom:0',
      'left:0',
      'right:0',
      'display:flex',
      'justify-content:space-between',
      'align-items:center',
      'padding:2px 8px',
      'background:rgba(180,155,100,0.82)',
      'backdrop-filter:blur(2px)',
      'font-size:9px',
      'font-style:italic',
      'letter-spacing:0.08em',
      'color:#fff',
      'pointer-events:none',
    ].join(';');
    bar.innerHTML =
      '<span id="gem-preview-bar__left">One of a kind</span>' +
      '<span id="gem-preview-bar__right"></span>';

    var initNum = getItemNumberFromSrc(src);
    if (initNum) {
      bar.querySelector('#gem-preview-bar__right').textContent = initNum;
      bar.style.display = 'flex';
    } else {
      bar.style.display = 'none';
    }

    imgWrap.appendChild(thumb);
    imgWrap.appendChild(bar);
    wrapper.appendChild(label);
    wrapper.appendChild(imgWrap);
    anchor.parentElement.insertBefore(wrapper, anchor);
    previewThumbInserted = true;
    log('プレビューサムネイル挿入完了');
  }

  function getItemNumberFromSrc(src) {
    if (!src) return null;
    var basename = src.split('?')[0].split('/').pop().replace(/\.[^.]+$/, '').toLowerCase();
    var m = basename.match(/[_-](\d{3})(?:[_\-.]|$)/);
    return m ? '#' + m[1] : null;
  }

  function syncPreviewThumb(src) {
    if (!src) return;
    var thumb = document.getElementById(PREVIEW_THUMB_ID);
    if (!thumb) {
      insertPreviewThumb();
      thumb = document.getElementById(PREVIEW_THUMB_ID);
    }
    if (thumb) {
      thumb.src = src;
      var wrapper = document.getElementById(PREVIEW_WRAPPER_ID);
      if (wrapper && stoneSelected && isMetalColorSelected()) wrapper.style.display = 'flex';
      var bar = document.getElementById('gem-preview-bar');
      if (bar) {
        var num = getItemNumberFromSrc(src);
        if (num) {
          var right = bar.querySelector('#gem-preview-bar__right');
          if (right) right.textContent = num;
          bar.style.display = 'flex';
        } else {
          bar.style.display = 'none';
        }
      }
      log('プレビューサムネイル同期:', src);
    }
  }

  function watchPreviewThumb() {
    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (!document.getElementById(PREVIEW_WRAPPER_ID)) {
          previewThumbInserted = false;
          insertPreviewThumb();
        }
      }, 400);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function watchThumbClickForPreview() {
    document.addEventListener('click', function (e) {
      if (!e.target.closest('a.thumbnail')) return;
      if (isMetalColorSelected()) return;
      setTimeout(function () {
        syncPreviewThumb(getCurrentMainSrc());
      }, 400);
    });
  }

  /* -------------------------------------------------------
     メイン画像切り替え（v29: サムネイルクリック委任方式）
  ------------------------------------------------------- */

  function findThumbnailBySrc(src) {
    if (!src) return null;
    var targetFilename = src.split('?')[0].split('/').pop().replace(/\.[^.]+$/, '').toLowerCase();
    var thumbs = document.querySelectorAll('a.thumbnail[data-media-id]');
    for (var i = 0; i < thumbs.length; i++) {
      var img = thumbs[i].querySelector('img');
      if (!img) continue;
      var thumbSrc = img.src || img.getAttribute('data-lazy-src') || img.getAttribute('data-src') || '';
      var thumbFilename = thumbSrc.split('?')[0].split('/').pop().replace(/\.[^.]+$/, '').toLowerCase();
      var baseTarget = targetFilename.replace(/_\d+x[^_]*$/, '').replace(/_\d+x$/, '');
      var baseThumb  = thumbFilename.replace(/_\d+x[^_]*$/, '').replace(/_\d+x$/, '');
      if (baseTarget && baseThumb && baseTarget === baseThumb) return thumbs[i];
    }
    return null;
  }

  function swapMainImage(src) {
    if (!src) return;

    var thumb = findThumbnailBySrc(src);
    if (thumb) {
      thumb.click();
      log('サムネイルクリック委任:', src);
      syncPreviewThumb(src);
      setTimeout(function () {
        var activeImg = document.querySelector(
          '.product-media[style*="display: block"] img:not(.zoomImg)'
        );
        if (activeImg) {
          activeImg.dispatchEvent(new Event('lazyload'));
          activeImg.dispatchEvent(new Event('load'));
          var hqSrc = activeImg.getAttribute('data-src') || activeImg.getAttribute('data-lazy-src');
          if (hqSrc
              && hqSrc.indexOf('{width}') === -1
              && hqSrc.indexOf('%7Bwidth%7D') === -1) {
            activeImg.src = upgradeImageSrc(hqSrc);
          }
        }
      }, 300);
      return;
    }

    log('フォールバック直接書き換え:', src);
    var activeMedia = document.querySelector('.product-media[style*="display: block"]')
                   || document.querySelector('.product-media.is-active')
                   || document.querySelector('.main .product-media');

    if (activeMedia) {
      var link = activeMedia.querySelector('a.main-img-link');
      if (link) link.href = src;

      var img = activeMedia.querySelector('img:not(.zoomImg)');
      if (img) {
        img.src = upgradeImageSrc(src);
        if (img.hasAttribute('data-lazy-src')) img.setAttribute('data-lazy-src', src);
        if (img.hasAttribute('data-src'))      img.setAttribute('data-src', src);
        img.dispatchEvent(new Event('lazyload'));
        img.dispatchEvent(new Event('load'));
      }

      var zoomImg = activeMedia.querySelector('img.zoomImg');
      if (zoomImg) zoomImg.src = upgradeImageSrc(src);
    }

    syncPreviewThumb(src);
  }

  /* -------------------------------------------------------
     カラー選択処理
  ------------------------------------------------------- */

  var currentColorKey = null;
  var metalSelected   = false;
  var stoneSelected   = false;

  function onColorSelected(colorKey) {
    if (!window.GEM_SWAP_CONFIG) { warn('GEM_SWAP_CONFIG 未定義'); return; }
    var stoneNum = getStoneNumber();
    if (!stoneNum) { warn('宝石番号取得失敗（stoneNum が null）'); return; }
    var filename = buildFilename(colorKey, stoneNum);
    log('検索:', filename);
    var src = findProductImage(filename);
    if (src) swapMainImage(src);
    else warn('画像が見つかりません:', filename);
  }

  function isMetalColorSelected() {
    var metalOption = document.querySelector('.gem-metal-color-option');
    if (!metalOption) return false;
    return !!metalOption.querySelector('input.mw-option__control:checked');
  }

  function getCurrentColorKeyFromDOM() {
    var checked = document.querySelector('.mw-apo-container input.mw-option__control:checked');
    if (!checked) return null;
    var metalText = getMetalText(checked);
    if (isPlatinum(metalText)) return 'platinum';
    return getColorKeyFromElement(checked);
  }

  /* -------------------------------------------------------
     ターゲット探索（クリック・change用）
  ------------------------------------------------------- */

  function findSwatchTarget(el) {
    return (
      el.closest('.mw-option__swatch-media')  ||
      el.closest('.mw-option__swatch-image')  ||
      el.closest('.mw-option__value')         ||
      el.closest('.mw-stack__item-swatch')    ||
      el.closest('.mw-option__button')
    );
  }

  /* -------------------------------------------------------
     イベントバインド
  ------------------------------------------------------- */

  function bindEvents(container) {
    container.addEventListener('change', function (e) {
      if (!e.target.classList.contains('mw-option__control')) return;
      var metalText = getMetalText(e.target);
      var colorKey = isPlatinum(metalText) ? 'platinum' : getColorKeyFromElement(e.target);
      if (colorKey) {
        currentColorKey = colorKey;
        metalSelected = true;
        onColorSelected(colorKey);
      }
    });

    container.addEventListener('click', function (e) {
      var target = findSwatchTarget(e.target);
      if (!target) return;
      var metalText = getMetalText(target);
      var colorKey = isPlatinum(metalText) ? 'platinum' : getColorKeyFromElement(target);
      if (colorKey) {
        currentColorKey = colorKey;
        metalSelected = true;
        setTimeout(function () { onColorSelected(colorKey); }, 150);
      }
    });

    // ホバーでツールチップ表示（地金カラーのみ）
    container.addEventListener('mouseover', function (e) {
      var target = findTooltipTarget(e.target);
      if (!target) return;
      var metalText = getMetalText(target);
      var colorKey = isPlatinum(metalText) ? 'platinum' : getColorKeyFromElement(target);
      if (!colorKey) return;
      var src = getColorImageSrc(colorKey);
      if (src) showTooltip(src, target);
    });

    container.addEventListener('mouseout', function (e) {
      if (findTooltipTarget(e.target)) hideTooltip();
    });

    log('bindEvents 完了');
  }

  /* -------------------------------------------------------
     宝石スウォッチ変更時の画像再適用
  ------------------------------------------------------- */

  function watchStoneSelection() {
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.gem-swatch-item')) return;
      stoneSelected = true;
      var resolvedKey = currentColorKey || getCurrentColorKeyFromDOM();
      setTimeout(function () {
        var colorKey = resolvedKey || getCurrentColorKeyFromDOM();
        if (colorKey) {
          currentColorKey = colorKey;
          onColorSelected(colorKey);
        } else {
          warn('宝石選択後: カラーキー取得失敗');
        }
      }, 500);
    });

    document.addEventListener('click', function (e) {
      var stoneOptionEl = getStoneOptionEl();
      if (!stoneOptionEl) return;
      if (!stoneOptionEl.contains(e.target)) return;
      if (!e.target.closest('.mw-option__value')) return;
      stoneSelected = true;
      var resolvedKey = currentColorKey || getCurrentColorKeyFromDOM();
      if (resolvedKey) {
        setTimeout(function () {
          var colorKey = resolvedKey || getCurrentColorKeyFromDOM();
          if (colorKey) {
            currentColorKey = colorKey;
            onColorSelected(colorKey);
          }
        }, 600);
      }
    });
  }

  /* -------------------------------------------------------
     APO再描画の監視
  ------------------------------------------------------- */

  function observeApo(container) {
    var rebindTimer = null;
    new MutationObserver(function () {
      clearTimeout(rebindTimer);
      rebindTimer = setTimeout(function () {
        var newContainer = document.querySelector('.mw-apo-container');
        if (newContainer) {
          tagMetalColorOption();
          bindEvents(newContainer);
          log('APO再描画検知 → 再バインド完了');
        }
      }, 300);
    }).observe(container, { childList: true, subtree: true });
  }

  /* -------------------------------------------------------
     初期化
  ------------------------------------------------------- */

  function tryInit() {
    var container = document.querySelector('.mw-apo-container');
    if (!container) return false;
    tagMetalColorOption();
    bindEvents(container);
    watchStoneSelection();
    observeApo(container);
    insertPreviewThumb();
    watchPreviewThumb();
    watchThumbClickForPreview();
    log('初期化完了 (v32)');
    return true;
  }

  function init() {
    if (tryInit()) return;
    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      if (tryInit() || attempts > 30) clearInterval(timer);
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();